import React from 'react';
import cn from '../../lib/cn';

/**
 * Seamless horizontal ticker. The children are rendered twice and the track
 * translates by exactly -50%, so the loop has no visible seam. The duplicate
 * is hidden from assistive tech.
 */
export function Marquee({ children, className, speed = 'normal', pauseOnHover = true }) {
  const animation = speed === 'slow' ? 'animate-marquee-slow' : 'animate-marquee';

  return (
    <div className={cn('relative overflow-hidden edge-fade-x', className)}>
      <div
        className={cn(
          'flex w-max',
          animation,
          pauseOnHover && 'hover:[animation-play-state:paused]'
        )}
      >
        <div className="flex shrink-0 items-center">{children}</div>
        <div className="flex shrink-0 items-center" aria-hidden="true">
          {children}
        </div>
      </div>
    </div>
  );
}

export default Marquee;
